/**
 *  @class
 *  @function SlideShowMobileContainer
 */
if (!customElements.get('slide-show-mobile-container')) {
  class SlideShowMobileContainer extends HTMLElement {
    constructor() {
      super();
      const slideshow = this,
        dataset = slideshow.dataset;

      let main_slideshow = document.querySelector(`[data-slideshow="${dataset.slideshowReference}"]`),
        slideshow_slides = Array.from(slideshow.querySelectorAll('.mobile-slide'));

      let slider = Flickity.data(main_slideshow);
      if (slider) {
        slider.on('change', function (index) {
          slideshow.querySelector(".mobile-slide.visible").classList.remove("visible")
          slideshow_slides[index].classList.add("visible")
        });
      }
    }
  }
  customElements.define('slide-show-mobile-container', SlideShowMobileContainer);
}